<!--
 * @Author: wangwenshuai 644586996@qq.com
 * @Date: 2022-08-12 09:33:10
 * @LastEditors: wangwenshuai 644586996@qq.com
 * @LastEditTime: 2022-11-08 15:18:28
 * @FilePath: \dbarsdgs\src\components\DataServer\Statistics\DataSat.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="DataSat">
    <div
      v-for="(item, index) in data"
      class="DataSat_box"
      :key="index"
      @click="openPage(item)"
    >
      <div class="img">
        <img
          :src="require(`@/assets/image/DataHub/special_${index + 1}.png`)"
          alt=""
        />
      </div>

      <div class="p">
        <p>{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return [
        {
          url: "https://data.casearth.cn/thematic/Global_ocean_eddies",
          name: this.$t('DataSatName.name1')
        },
        { url: "https://data.casearth.cn/thematic/desert_locust", name: this.$t('DataSatName.name2') },
        { url: "https://data.casearth.cn/thematic/glc_fcs30", name: this.$t('DataSatName.name3')},
      ];
    },
  },
  data() {
    return {
      // data: [
      //   { url: "https://data.casearth.cn/thematic/Global_ocean_eddies" },
      //   { url: "https://data.casearth.cn/thematic/desert_locust" },
      //   { url: "https://data.casearth.cn/thematic/glc_fcs30" },
      // ],
    };
  },
  methods: {},
  methods: {
    openPage(item) {
      window.open(item.url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.DataSat {
  display: flex;
  flex-direction: row;
  .DataSat_box:last-child {
    margin-right: 0;
  }
  .DataSat_box {
    cursor: pointer;
    height: 164px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    margin-right: 12px;
    transition: 0.2s;
    &:hover {
      opacity: 0.8;
      transition: 0.2s;
    }
    .img {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.4);
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    .p {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      color: #fff;
      font-weight: 600;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>